export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS"
export const MATCH_OTP = "MATCH_OTP";
export const MOBILE = "MOBILE";
export const EVENTDETAILS = "EVENTDETAILS"

